import React from 'react'
import { useSelector } from 'react-redux'
import UserProfileEditor from '../contentPages/UserProfileEditor'

const UserProfile = () => {
	const userLogin = useSelector(state => state.userLogin)
	const { userInfo: user } = userLogin
	const userId = user._id

	return <UserProfileEditor userId={userId} />
}

export default UserProfile
